module.exports = __webpack_public_path__ + "static/altana_thumb-2b6980b9b9639cc9d943de71b50336ed.jpg";